import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useContext, useState } from "react";
import DocNavigationButton from "../../../components/DocNavigationButton";
import RefreshLimitsButton from "../../../components/poc/RefreshLimitsButton";
import SpinningIcon from "../../../components/SpinningIcon";
import AppPage from "../../../components/structure/AppPage";
import { CustomerFeatureFlagsContext } from "../../../contexts/CustomerFeatureFlagsContext";
import AddNewUserButton from "./components/AddNewUserButton";
import AddNewUserModal from "./components/AddNewUserModal";
import AttachExistingCustomerToMSSPButton from "./components/AttachExistingCustomerToMSSPButton";
import AttachExistingCustomerToMSSPModal from "./components/AttachExistingCustomerToMSSPModal";
import AutoSuggestionGenerationButton from "./components/AutoSuggestionGenerationButton";
import BuildGRCUser from "./components/BuildGRCUser";
import ClearLocalStorageButton from "./components/ClearLocalStorageButton";
import ClearRunningTasksButton from "./components/ClearRunningTasksButton";
import ClearSecretsCacheButton from "./components/ClearSecretsCacheButton";
import CollectEntitiesButton from "./components/CollectEntitiesButton";
import CollectVulnerabilitiesButton from "./components/CollectVulnerabilitiesButton";
import CopyTenantsToBreezeMSSPButton from "./components/CopyTenantsToBreezeMSSPButton";
import CopyTenantsToBreezeMSSPModal from "./components/CopyTenantsToBreezeMSSPModal";
import CreateHeatmapButton from "./components/CreateHeatmapButton";
import CreateInAppNotification from "./components/CreateInAppNotifications";
import CreateManualInAppNotification from "./components/CreateManualInAppNotification";
import DeleteControlButton from "./components/DeleteControlButton";
import DeleteControlModal from "./components/DeleteControlModal";
import EditScheduledNotifications from "./components/EditScheduledNotifications";
import GenerateInternalDashboardSnapshotsButton from "./components/GenerateInternalDashboardSnapshotsButton";
import InitiateNewEnvButton from "./components/InitiateNewEnvButton";
import InitiateNewEnvModal from "./components/InitiateNewEnvModal";
import ManageCustomerFeatureFlagsButton from "./components/ManageCustomerFeatureFlagsButton";
import ManageCustomerFeatureFlagsTable from "./components/ManageCustomerFeatureFlagsTable";
import ManageEnvFeatureFlagsButton from "./components/ManageEnvFeatureFlagsButton";
import ManageEnvFeatureFlagsTable from "./components/ManageEnvFeatureFlagsTable";
import ManagePlatformSecretButton from "./components/ManagePlatformSecretButton";
import ManagePlatformSecretTable from "./components/ManagePlatformSecretTable";
import ManagePOCLimitsButton from "./components/ManagePOCLimitsButton";
import ManagePOCLimitsModal from "./components/ManagePOCLimitsModal";
import MigrateDataButton from "./components/MigrateDataButton";
import NightlyFlowButton from "./components/NightlyFlowButton";
import OffboardCustomerButton from "./components/OffboardCustomerButton";
import OffboardCustomerModal from "./components/OffboardCustomerModal";
import OnboardCustomerButton from "./components/OnboardCustomerButton";
import OnboardCustomerModal from "./components/OnboardCustomerModal";
import RefreshEmailScheduler from "./components/RefreshEmailScheduler";
import RefreshEntitiesCacheButton from "./components/RefreshEntitiesCacheButton";
import RefreshEntitiesCacheModal from "./components/RefreshEntitiesCacheModal";
import RefreshPostgresEntitiesCacheButton from "./components/RefreshPostgresEntitiesCacheButton";
import RefreshPostgresEntitiesCacheModal from "./components/RefreshPostgresEntitiesCacheModal";
import RemoveSlackScheduledMessage from "./components/RemoveSlackScheduledMessage";
import ResetRemediationButton from "./components/ResetRemediationButton";
import S3BucketConverter from "./components/S3BucketConverter.jsx";
import ScanPostureButton from "./components/ScanPostureButton";
import ScanSpecificControlButton from "./components/ScanSpecificControlButton";
import SendMicrosoftTeamsAdaptiveCardMessage from "./components/SendMicrosoftTeamsAdaptiveCardMessage";
import SendScheduledNotificationButton from "./components/SendScheduledNotificationButton";
import SetMyRoleButton from "./components/SetMyRoleButton";
import SetMyRoleModal from "./components/SetMyRoleModal";
import SmartAssetsGenerationButton from "./components/SmartAssetsGenerationButton";
import UpgradeUserToMSSPButton from "./components/UpgradeUserToMSSPButton";
import UpgradeUserToMSSPModal from "./components/UpgradeUserToMSSPModal";
import UploadAgentConfigButton from "./components/UploadAgentConfigButton";
import UploadAgentImageButton from "./components/UploadAgentImageButton";

const SupportDevTools = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth0();
  const [showCustomerFeatureFlags, setShowCustomerFeatureFlags] =
    useState(false);
  const [showEnvFeatureFlags, setShowEnvFeatureFlags] = useState(false);
  const [showPlatformSecret, setShowPlatformSecret] = useState(false);
  const [showOnboardCustomerModal, setShowOnboardCustomerModal] =
    useState(false);
  const [showInitiateNewEnvModal, setShowInitiateNewEnvModal] = useState(false);
  const [showAddNewUserModal, setShowAddNewUserModal] = useState(false);
  const [showUpgradeUserToMSSPModal, setShowUpgradeUserToMSSPModal] =
    useState(false);
  const [
    showAttachExistingCustomerToMSSPModal,
    setShowAttachExistingCustomerToMSSPModal,
  ] = useState(false);
  const [showOffboardCustomerModal, setShowOffboardCustomerModal] =
    useState(false);
  const [showSetMyRoleModal, setShowSetMyRoleModal] = useState(false);
  const [showS3BucketConverter, setShowS3BucketConverter] = useState(false);
  const [showManagePOCLimitsModal, setShowManagePOCLimitsModal] =
    useState(false);
  const [
    showCopyTenantsToBreezeMSSPModal,
    setShowCopyTenantsToBreezeMSSPModal,
  ] = useState(false);
  const [showRefreshEntitiesCacheModal, setShowRefreshEntitiesCacheModal] =
    useState(false);
  const [
    showRefreshPostgresEntitiesCacheModal,
    setShowRefreshPostgresEntitiesCacheModal,
  ] = useState(false);
  const [showDeleteControlModal, setShowDeleteControlModal] = useState(false);
  const { autoRemediationActive } = useContext(CustomerFeatureFlagsContext);

  const [testError, setTestError] = useState(false);
  if (testError) {
    throw new Error("Test error");
  }

  return (
    <>
      {user.email.includes("@breeze") ? (
        <AppPage
          title="Support & Dev Tools"
          subtitle="NOT CUSTOMER-FACING; for internal use only!"
        >
          <Grid container spacing={3} direction={"column"}>
            <Grid item>
              <DocNavigationButton />
            </Grid>
            {/* Collect/Scan */}
            <Grid item>
              <Grid container spacing={3} direction={"row"}>
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Collect/Scan
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* NIGHTLY FLOW: full periodic nightly flow - scan & collection*/}
                    <Grid item>
                      <NightlyFlowButton
                        disabled={isLoading}
                        setLoading={setIsLoading}
                        loadingMessage={"Running nightly flow..."}
                      />
                    </Grid>
                    {/* SCAN: posture */}
                    <Grid item>
                      <ScanPostureButton
                        disabled={isLoading}
                        setLoading={setIsLoading}
                        loadingMessage={"Scanning posture..."}
                      />
                    </Grid>
                    {/* SCAN: specific control */}
                    <Grid item>
                      <ScanSpecificControlButton
                        disabled={isLoading}
                        setLoading={setIsLoading}
                        loadingMessage={"Scanning specific control..."}
                      />
                    </Grid>
                    {/* COLLECTION: entities */}
                    <Grid item>
                      <CollectEntitiesButton
                        setLoading={setIsLoading}
                        loadingMessage={`Collecting new entities...`}
                        startIcon={<SpinningIcon isLoading={isLoading} />}
                        disabled={isLoading}
                      >
                        {isLoading
                          ? "Collecting..."
                          : `Collect new entities...`}
                      </CollectEntitiesButton>
                    </Grid>
                    {/* COLLECTION: vulnerabilities */}
                    <Grid item>
                      <CollectVulnerabilitiesButton
                        setLoading={setIsLoading}
                        loadingMessage={"Collecting new vulnerabilities..."}
                        startIcon={<SpinningIcon isLoading={isLoading} />}
                        disabled={isLoading}
                      >
                        {isLoading
                          ? "Collecting..."
                          : "Collect new vulnerabilities..."}
                      </CollectVulnerabilitiesButton>
                    </Grid>
                    {/* CREATE HEATMAPS */}
                    <Grid item>
                      <CreateHeatmapButton
                        setLoading={setIsLoading}
                        loadingMessage={"Creating heatmaps..."}
                        disabled={isLoading}
                      >
                        {isLoading ? "Creating..." : "Create Heatmaps"}
                      </CreateHeatmapButton>
                    </Grid>
                    {/* GENERATE INTERNAL DASHBOARD SNAPSHOTS */}
                    <Grid item>
                      <GenerateInternalDashboardSnapshotsButton />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Cache */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Cache
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* CLEAR TASKS */}
                    <Grid item>
                      <ClearRunningTasksButton />
                    </Grid>
                    {/* CLEAR SECRETS */}
                    <Grid item>
                      <ClearSecretsCacheButton />
                    </Grid>
                    {/* CLEAR LOCAL STORAGE */}
                    <Grid item>
                      <ClearLocalStorageButton />
                    </Grid>
                    {/* REFRESH ENTITIES CACHE */}
                    <Grid item>
                      <RefreshEntitiesCacheButton
                        handleOnClick={() =>
                          setShowRefreshEntitiesCacheModal(true)
                        }
                      />
                      <RefreshEntitiesCacheModal
                        open={showRefreshEntitiesCacheModal}
                        handleClose={() =>
                          setShowRefreshEntitiesCacheModal(false)
                        }
                      />
                    </Grid>
                    {/* REFRESH POSTGRES ENTITIES CACHE */}
                    <Grid item>
                      <RefreshPostgresEntitiesCacheButton
                        handleOnClick={() =>
                          setShowRefreshPostgresEntitiesCacheModal(true)
                        }
                      />
                      <RefreshPostgresEntitiesCacheModal
                        open={showRefreshPostgresEntitiesCacheModal}
                        handleClose={() =>
                          setShowRefreshPostgresEntitiesCacheModal(false)
                        }
                      />
                    </Grid>
                    {/* POC LIMITS */}
                    <Grid item>
                      <RefreshLimitsButton />
                    </Grid>
                    {/* MANAGE POC LIMITS */}
                    <Grid item>
                      <ManagePOCLimitsButton
                        handleOnClick={() => setShowManagePOCLimitsModal(true)}
                      />
                      <ManagePOCLimitsModal
                        open={showManagePOCLimitsModal}
                        handleClose={() => setShowManagePOCLimitsModal(false)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Assets */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Assets
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* ASSETS AUTO-SUGGESTIONS */}
                    <Grid item>
                      <AutoSuggestionGenerationButton />
                    </Grid>
                    {/* ASSETS SMART-ASSETS */}
                    <Grid item>
                      <SmartAssetsGenerationButton />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Agent */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Agent
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    <Grid item>
                      <UploadAgentImageButton
                        disabled={isLoading}
                        setLoading={setIsLoading}
                        loadingMessage={"Uploading agent image..."}
                      >
                        Upload agent image
                      </UploadAgentImageButton>
                    </Grid>
                    <Grid item>
                      <UploadAgentConfigButton
                        disabled={isLoading}
                        setLoading={setIsLoading}
                        loadingMessage={"Uploading agent config..."}
                      >
                        Upload agent config
                      </UploadAgentConfigButton>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Notifications */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Notifications
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* NOTIFICATIONS: send scheduled notification */}
                    <Grid item>
                      <SendScheduledNotificationButton />
                    </Grid>
                    <Grid item>
                      <CreateInAppNotification />
                    </Grid>
                    <Grid item>
                      <CreateManualInAppNotification />
                    </Grid>
                    <Grid item>
                      <RefreshEmailScheduler />
                    </Grid>
                    <Grid item>
                      <RemoveSlackScheduledMessage />
                    </Grid>
                    <Grid item>
                      <EditScheduledNotifications />
                    </Grid>
                    <Grid item>
                      <SendMicrosoftTeamsAdaptiveCardMessage />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container spacing={3} direction={"row"}>
                {/* Users */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Users
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* Onboard New Customer */}
                    <Grid item>
                      <OnboardCustomerButton
                        handleOnClick={() => setShowOnboardCustomerModal(true)}
                      />
                      <OnboardCustomerModal
                        open={showOnboardCustomerModal}
                        handleClose={() => setShowOnboardCustomerModal(false)}
                      />
                    </Grid>
                    {/* Initiate New Env */}
                    <Grid item>
                      <InitiateNewEnvButton
                        handleOnClick={() => setShowInitiateNewEnvModal(true)}
                      />
                      <InitiateNewEnvModal
                        open={showInitiateNewEnvModal}
                        handleClose={() => setShowInitiateNewEnvModal(false)}
                      />
                    </Grid>
                    {/* Add New User */}
                    <Grid item>
                      <AddNewUserButton
                        handleOnClick={() => setShowAddNewUserModal(true)}
                      />
                      <AddNewUserModal
                        open={showAddNewUserModal}
                        handleClose={() => setShowAddNewUserModal(false)}
                      />
                    </Grid>
                    {/* Upgrade User to MSSP */}
                    <Grid item>
                      <UpgradeUserToMSSPButton
                        handleOnClick={() =>
                          setShowUpgradeUserToMSSPModal(true)
                        }
                      />
                      <UpgradeUserToMSSPModal
                        open={showUpgradeUserToMSSPModal}
                        handleClose={() => setShowUpgradeUserToMSSPModal(false)}
                      />
                    </Grid>
                    {/* Attach Existing Customer to MSSP */}
                    <Grid item>
                      <AttachExistingCustomerToMSSPButton
                        handleOnClick={() =>
                          setShowAttachExistingCustomerToMSSPModal(true)
                        }
                      />
                      <AttachExistingCustomerToMSSPModal
                        open={showAttachExistingCustomerToMSSPModal}
                        handleClose={() =>
                          setShowAttachExistingCustomerToMSSPModal(false)
                        }
                      />
                    </Grid>
                    {/* Copy Tenants to Breeze MSSP */}
                    <Grid item>
                      <CopyTenantsToBreezeMSSPButton
                        handleOnClick={() =>
                          setShowCopyTenantsToBreezeMSSPModal(true)
                        }
                      />
                      <CopyTenantsToBreezeMSSPModal
                        open={showCopyTenantsToBreezeMSSPModal}
                        handleClose={() =>
                          setShowCopyTenantsToBreezeMSSPModal(false)
                        }
                      />
                    </Grid>
                    {/* Offboard Customer */}
                    <Grid item>
                      <OffboardCustomerButton
                        handleOnClick={() => setShowOffboardCustomerModal(true)}
                      />
                      <OffboardCustomerModal
                        open={showOffboardCustomerModal}
                        handleClose={() => setShowOffboardCustomerModal(false)}
                      />
                    </Grid>
                    {/* Set My Role */}
                    <Grid item>
                      <SetMyRoleButton
                        handleOnClick={() => setShowSetMyRoleModal(true)}
                      />
                      <SetMyRoleModal
                        open={showSetMyRoleModal}
                        handleClose={() => setShowSetMyRoleModal(false)}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Miscellaneous */}
                <Grid item>
                  <Typography variant="h6" style={{ marginBottom: "16px" }}>
                    Miscellaneous
                  </Typography>
                  <Grid container spacing={2} direction={"column"}>
                    {/* GRC USERS */}
                    <Grid item>
                      <BuildGRCUser
                        loadingMessage={"Collect Privileged Access"}
                        setLoading={setIsLoading}
                      />
                    </Grid>
                    {/* MIGRATION */}
                    <Grid item>
                      <MigrateDataButton />
                    </Grid>
                    {/* Manage Customer Feature Flags */}
                    <Grid item>
                      <ManageCustomerFeatureFlagsButton
                        handleOnClick={() =>
                          setShowCustomerFeatureFlags(!showCustomerFeatureFlags)
                        }
                      />
                      {showCustomerFeatureFlags ? (
                        <ManageCustomerFeatureFlagsTable />
                      ) : null}
                    </Grid>
                    {/* Manage Environment Feature Flags */}
                    <Grid item>
                      <ManageEnvFeatureFlagsButton
                        handleOnClick={() =>
                          setShowEnvFeatureFlags(!showEnvFeatureFlags)
                        }
                      />
                      {showEnvFeatureFlags ? (
                        <ManageEnvFeatureFlagsTable />
                      ) : null}
                    </Grid>
                    {/* Manage Platform Secret */}
                    <Grid item>
                      <ManagePlatformSecretButton
                        handleOnClick={() =>
                          setShowPlatformSecret(!showPlatformSecret)
                        }
                      />
                      {showPlatformSecret ? (
                        <ManagePlatformSecretTable />
                      ) : null}
                    </Grid>
                    {/* Demo auto-remediation  */}
                    {autoRemediationActive && (
                      <Grid item>
                        <ResetRemediationButton />
                      </Grid>
                    )}
                    <Grid item>
                      <S3BucketConverter
                        open={showS3BucketConverter}
                        onClose={() => setShowS3BucketConverter(false)}
                        setShowS3BucketConverter={setShowS3BucketConverter}
                      />
                    </Grid>
                    <Grid item>
                      <DeleteControlButton
                        handleOnClick={() => setShowDeleteControlModal(true)}
                      />
                      <DeleteControlModal
                        open={showDeleteControlModal}
                        handleClose={() => setShowDeleteControlModal(false)}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => setTestError(true)}
                      >
                        Test Global Error Page
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AppPage>
      ) : (
        <Box />
      )}
    </>
  );
};

export default SupportDevTools;
